import Router from './Router';
import axios from 'axios';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// Load axios
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;

    // Interceptors for 'bad' requests
    window.axios.interceptors.response.use(null, error => {

        // Exclude the interceptor for validation errors.
        if ([400,422].indexOf(error.response.status) !== -1) {
            return Promise.reject(error);
        }

        let pathname;

        switch (error.response.status) {
            default: pathname = 'error'; break;
            case 401: pathname = 'unauthorized'; break;
            case 403: pathname = 'unauthorized'; break;
            case 404: pathname = 'page.not.found'; break;
            case 500: pathname = 'servererror'; break;
            case 555: pathname = 'demomode'; break;
        }

        Router.replace({name:pathname, params: [Router.currentRoute.path]});
        return Promise.reject(error);
    });
}
else { console.error("CSRF token not found!!"); }

/**
 * Import AdminLTE
 */
import 'admin-lte';

import 'cropperjs/dist/cropper.min.css';
import Cropper from 'cropperjs';
window.Cropper = Cropper;
import { jsPDF } from 'jspdf';
window.jsPDF = jsPDF;
import autoTable from 'jspdf-autotable';
window.autoTable = autoTable;


